export default __webpack_public_path__ + "static/media/jeroen-2.84b6389b.jpg";